import { useState } from "react";
import { AutoComplete } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useNotes } from "../../../hooks";
import { useTranslation } from "react-i18next";

export default function SearchBar({ setActiveKey }) {
  const { notes } = useNotes();
  const [searchText, setSearchText] = useState("");
  const { t } = useTranslation();

  const [filteredResult, setFilteredResult] = useState(
    notes.map((t) => t.title),
  );

  const handleStringSearch = (value) => {
    setFilteredResult(
      notes.map((t) => t.title).filter((i) => i.includes(value)),
    );
  };

  return (
    <AutoComplete
      options={filteredResult.map(item => ({ value: item }))}
      value={searchText}
      allowClear
      prefix={<SearchOutlined />}
      placeholder={t("search")}
      notFoundContent={<div className="p-3 popover-theme">{t("not_found")}</div>}
      onSearch={(v) => handleStringSearch(v)}
      onChange={(v) => setSearchText(v)}
      onSelect={(v) => {
        const { id } = notes.find((t) => t.title === v);
        setActiveKey(`${id}`);
        document
          .getElementById(`scroll_note_${id}`)
          .scrollIntoView({ behavior: "smooth" });
      }}
      className="w-full"
    />
  );
}
